import { isMobile } from "react-device-detect"
import { generateLine } from "../../services/data"
import { useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { setPreview } from "../../store/reducers/general"
import { useDispatch } from "react-redux"
import { NoThumbnail } from "../no-thumbnail.jsx"

export function MockVideoCard({ video, previewLan, isReal = false }) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [isHover, setIsHover] = useState(false)
    const { image, title, length, channelImage, channelName } = video
    const englishLine = useRef(generateLine('en'))
    const hebrewLine = useRef(generateLine('he'))

    const handleClick = () => {
        if(!isReal) return
        dispatch(setPreview(false))
        navigate(`/video/${video._id}`)
    }

    return <div className="mock-video-card" onClick={handleClick} onMouseEnter={() => setIsHover(true)} onMouseLeave={() => setIsHover(false)}>
        {(isHover && isReal) && <div className="hover-card">
            <h3>{video.title}</h3>
            <p>מיקום : {video.ideaMaker.location}</p>
            <p>תקציב : {video.producer?.totalPrice ? video.producer.totalPrice + '₪' : 'לא ידוע עדיין'}</p>
        </div>}
        <div style={{ position: 'relative' }}>
            {image ? <img src={image} alt={title} className="thumbnail" /> : <NoThumbnail />}
            <p className={`length ${(previewLan) === 'he' ? 'length-he' : 'length-en'}`}>{length}</p>
        </div>
        <div className="lower">
            <img src={channelImage} />
            <div className="details" style={{ width: '70%' }} >
                <h3 style={{ textAlign: previewLan === 'he' ? 'right' : 'left' }}>{title}</h3>
                {isMobile && <p style={{ textAlign: previewLan === 'he' ? 'right' : 'left' }}>{channelName} • {previewLan === 'he' ? hebrewLine.current : englishLine.current}</p>}
                {!isMobile && <>
                    <p style={{ textAlign: previewLan === 'he' ? 'right' : 'left' }}>{channelName}</p>
                    {previewLan === 'he' ? <p style={{ textAlign: previewLan === 'he' ? 'right' : 'left' }}>{hebrewLine.current}</p> : <p style={{ textAlign: previewLan === 'he' ? 'right' : 'left' }}>{englishLine.current}</p>}
                </>}
            </div>
            <span className={`material-symbols-outlined dots ${previewLan === 'he' ? 'l' : 'r'}`}>more_vert</span>
        </div>
    </div>
}
